<script setup>
import { computed, useSlots } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  activeList: { type: String, required: true },
  page: { type: Number, default: 1 },
  totalPages: { type: Number, default: 1 },
  totalRows: { type: Number, default: 0 },
  visibleRows: { type: Number, default: 0 },
});

const emit = defineEmits(['changePage']);
const { t } = useI18n();
const slots = useSlots();
const hasStart = computed(() => Boolean(slots.start));
const listLabel = computed(() => {
  const labels = {
    rascunhos: t('SALES.LISTS.DRAFTS'),
    revisoes: t('SALES.LISTS.REVIEW'),
    entregues: t('SALES.LISTS.DELIVERED'),
    arquivados: t('SALES.LISTS.TRASH'),
    finalizados: t('SALES.LISTS.FINISHED'),
  };
  return labels[props.activeList] || labels.rascunhos;
});
</script>

<template>
  <div
    data-testid="sales-table-toolbar"
    class="flex min-h-14 flex-wrap items-center justify-between gap-3 px-[13px] py-2"
  >
    <div v-if="hasStart" class="flex items-center gap-2">
      <slot name="start" />
    </div>
    <div v-else>
      <h2 class="font-redHatDisplay text-lg font-semibold text-lais-text">
        {{ listLabel }}
      </h2>
    </div>
    <div
      data-testid="sales-table-pagination"
      class="flex items-center gap-2 text-sm text-lais-text"
    >
      <span>
        {{
          t('SALES.TABLE.PAGINATION', { count: visibleRows, total: totalRows })
        }}
      </span>
      <button
        type="button"
        class="inline-flex size-10 items-center justify-center rounded-[10px] text-lais-primary hover:bg-lais-bg-soft disabled:opacity-40"
        :disabled="page <= 1"
        :aria-label="t('SALES.ACTIONS.PREVIOUS')"
        @click="emit('changePage', page - 1)"
      >
        <span class="i-lucide-chevron-left size-4" aria-hidden="true" />
      </button>
      <span
        class="inline-flex size-10 items-center justify-center rounded-[10px] bg-lais-primary-50 text-base font-bold text-lais-primary"
      >
        {{ page }}
      </span>
      <button
        type="button"
        class="inline-flex size-10 items-center justify-center rounded-[10px] text-lais-primary hover:bg-lais-bg-soft disabled:opacity-40"
        :disabled="page >= totalPages"
        :aria-label="t('SALES.ACTIONS.NEXT')"
        @click="emit('changePage', page + 1)"
      >
        <span class="i-lucide-chevron-right size-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
